import type { EventTypeCmsMetaKeyOptionValueOption } from '../cms/content/ko/CmsContentContract';

export interface EventTypeInput {
    key: keyof typeof EventTypeCmsMetaKeyOptionValueOption;
    label: string;
}

export class EventType {
    /**
     * Key of the event type to be displayed.
     */
    public key: string;

    /**
     * Label that will be displayed to the end-user
     */
    public label: string;

    public constructor(input: EventTypeInput) {
        this.key = input.key;
        this.label = input.label;
    }
}
